import { anatomy } from '@shared/tokens/anatomy.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import * as stylex from '@stylexjs/stylex';

const fadeIn = stylex.keyframes({
  '0%': { opacity: 0 },
  '100%': { opacity: 1 },
});

const slideUp = stylex.keyframes({
  '0%': { transform: 'translateY(100%)' },
  '100%': { transform: 'translateY(0)' },
});

export const styles = stylex.create({
  overlay: {
    animationName: fadeIn,
    animationDuration: '0.3s',
    animationTimingFunction: 'ease-in-out',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    opacity: 0,
    transition: 'opacity 0.3s ease-in-out',
    zIndex: 1000,
  },
  overlayOpen: {
    opacity: 1,
  },
  drawer: {
    animationName: slideUp,
    animationDuration: '0.3s',
    animationTimingFunction: 'ease-in-out',
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'white',
    borderRadius: '20px 20px 0 0',
    boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.15)',
    zIndex: 1001,
    touchAction: 'none',
  },
  drawerSwapper: {
    width: '100%',
    height: anatomy['size-20'],
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'grab',
    userSelect: 'none',
    touchAction: 'none',
  },
  drawerLine: {
    width: anatomy['size-40'],
    height: anatomy['size-4'],
    borderRadius: '3px',
    backgroundColor: palette['grey-100'],
  },
  content: {
    padding: `${anatomy['size-24']} ${anatomy['size-20']}`,
    paddingTop: `${anatomy['size-12']}`,
    height: 'calc(100% - 20px)',
    overflowY: 'auto',
  },
});
